// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Image Viewer Page */
.image-viewer-page {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}
.viewer-header {
  text-align: center;
  padding: 2rem 0;
  margin-bottom: 2rem;
}
.viewer-header h2 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.viewer-header .viewer-subtitle {
  color: #6c757d;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}
.viewer-header .expiry-notice {
  color: #856404;
  font-size: 0.9rem;
  background: #fff3cd;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  display: inline-block;
  margin: 0;
}
.error-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 2rem auto;
}
.error-card h3 {
  color: #dc3545;
  font-weight: 600;
  margin-bottom: 1rem;
}
.error-card p {
  color: #6c757d;
  margin-bottom: 0.5rem;
}
.error-card p:last-child {
  margin-bottom: 0;
}
.no-images {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin: 2rem 0;
}
.no-images h4 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 1rem;
}
.no-images p {
  color: #6c757d;
  margin: 0;
}
/* Masonry Grid */
.masonry-container {
  padding: 0 1rem;
}
.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
  padding: 1rem 0;
}
.photo-item {
  cursor: pointer;
  overflow: hidden;
  border-radius: 8px;
  transition: transform 0.2s ease;
}
.photo-item:hover {
  transform: scale(1.02);
}
.photo-item img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
}
@media (max-width: 768px) {
  .photo-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
  .photo-item img {
    height: 150px;
  }
}
@media (max-width: 576px) {
  .photo-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
/* Image Card */
.image-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  break-inside: avoid;
}
.image-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}
.image-card.size-small {
  grid-row-end: span 1;
  grid-column-end: span 1;
}
.image-card.size-medium {
  grid-row-end: span 2;
  grid-column-end: span 2;
}
.image-card.size-large {
  grid-row-end: span 3;
  grid-column-end: span 3;
}
.image-container {
  position: relative;
  width: 100%;
}
.image-container img,
.image-container video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}
.image-container .image-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  padding: 1rem;
  border-radius: 8px;
}
.image-container .image-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #6c757d;
  background: #f8f9fa;
}
.image-container .image-error i {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}
.video-thumbnail {
  position: relative;
}
.video-thumbnail .video-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-thumbnail .video-overlay i {
  color: white;
  font-size: 1.5rem;
}
.image-info {
  padding: 1rem;
}
.image-info .image-filename {
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  word-break: break-word;
}
.image-info .image-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #6c757d;
}
.image-info .image-meta .file-size,
.image-info .image-meta .upload-date {
  flex: 1;
}
.image-info .image-meta .upload-date {
  text-align: right;
}
/* Load More */
.load-more-trigger {
  padding: 2rem 0;
  text-align: center;
}
.loading-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.loading-more p {
  color: #6c757d;
  margin: 0;
}
.end-message {
  text-align: center;
  padding: 2rem 0;
}
.end-message p {
  color: #6c757d;
  margin: 0;
  font-style: italic;
}
/* Image Modal */
.image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.image-modal {
  background: #1a1a1a;
  border-radius: 12px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: #2c2c2c;
  border-bottom: 1px solid #444;
}
.modal-header .modal-title {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.modal-header .modal-title h5 {
  color: white;
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.modal-header .modal-title .image-counter {
  color: #adb5bd;
  font-size: 0.8rem;
}
.modal-header .modal-actions {
  display: flex;
  gap: 0.5rem;
}
.modal-header .modal-actions .btn {
  border-radius: 6px;
  padding: 0.375rem 0.75rem;
}
.modal-content {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}
.modal-content .modal-image,
.modal-content .modal-video {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.7);
  border: none;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}
.nav-button:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: translateY(-50%) scale(1.1);
}
.nav-button.nav-previous {
  left: 1rem;
}
.nav-button.nav-next {
  right: 1rem;
}
.modal-footer {
  padding: 1rem 1.5rem;
  background: #2c2c2c;
  border-top: 1px solid #444;
}
.modal-footer .image-details {
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
}
.modal-footer .image-details .detail-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #adb5bd;
  font-size: 0.9rem;
}
.modal-footer .image-details .detail-item i {
  color: #6c757d;
}
/* Skeleton Loading */
.skeleton,
.image-card:has(.skeleton-container) {
  pointer-events: none;
}
.skeleton .skeleton-container,
.image-card:has(.skeleton-container) .skeleton-container {
  position: relative;
  overflow: hidden;
  background: #f0f0f0;
}
.skeleton .skeleton-container::after,
.image-card:has(.skeleton-container) .skeleton-container::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
  animation: shimmer 1.5s infinite;
}
.skeleton .skeleton-image,
.image-card:has(.skeleton-container) .skeleton-image {
  width: 100%;
  background: #e0e0e0;
  border-radius: 0;
}
.skeleton .skeleton-filename,
.image-card:has(.skeleton-container) .skeleton-filename {
  height: 16px;
  background: #e0e0e0;
  border-radius: 4px;
  margin-bottom: 0.5rem;
  width: 80%;
  position: relative;
  overflow: hidden;
}
.skeleton .skeleton-filename::after,
.image-card:has(.skeleton-container) .skeleton-filename::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
  animation: shimmer 1.5s infinite;
}
.skeleton .skeleton-filesize,
.image-card:has(.skeleton-container) .skeleton-filesize {
  height: 12px;
  background: #e0e0e0;
  border-radius: 4px;
  width: 60px;
  position: relative;
  overflow: hidden;
}
.skeleton .skeleton-filesize::after,
.image-card:has(.skeleton-container) .skeleton-filesize::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
  animation: shimmer 1.5s infinite;
}
.skeleton .skeleton-date,
.image-card:has(.skeleton-container) .skeleton-date {
  height: 12px;
  background: #e0e0e0;
  border-radius: 4px;
  width: 80px;
  position: relative;
  overflow: hidden;
}
.skeleton .skeleton-date::after,
.image-card:has(.skeleton-container) .skeleton-date::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
  animation: shimmer 1.5s infinite;
}
@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
/* Responsive Design */
@media (max-width: 768px) {
  .viewer-header {
    padding: 1rem 0;
  }
  .viewer-header h2 {
    font-size: 1.75rem;
  }
  .viewer-header .viewer-subtitle {
    font-size: 1rem;
  }
  .masonry-grid {
    gap: 0.75rem;
  }
  .masonry-column {
    gap: 0.75rem;
  }
  .image-info {
    padding: 0.75rem;
  }
  .image-info .image-meta {
    flex-direction: column;
    gap: 0.25rem;
  }
  .image-info .image-meta .upload-date {
    text-align: left;
  }
  .image-modal {
    max-width: 95vw;
    max-height: 95vh;
  }
  .modal-header {
    padding: 0.75rem 1rem;
  }
  .modal-header .modal-title h5 {
    font-size: 0.9rem;
  }
  .modal-header .modal-actions .btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem;
  }
  .nav-button {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
  .nav-button.nav-previous {
    left: 0.5rem;
  }
  .nav-button.nav-next {
    right: 0.5rem;
  }
  .modal-footer {
    padding: 0.75rem 1rem;
  }
  .modal-footer .image-details {
    gap: 1rem;
    font-size: 0.8rem;
  }
}
/* Image Skeleton */
.image-skeleton {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}
.skeleton-image {
  width: 100%;
  height: 200px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
}
@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.skeleton-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  padding: 1rem 0;
}
/* Video overlay for gallery */
.video-overlay-gallery {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.video-overlay-gallery i {
  color: white;
  font-size: 1.5rem;
}
@media (max-width: 576px) {
  .masonry-container {
    padding: 0 0.5rem;
  }
  .error-card,
  .no-images {
    margin: 1rem;
    padding: 2rem 1.5rem;
  }
  .viewer-header .expiry-notice {
    font-size: 0.8rem;
    padding: 0.375rem 0.75rem;
  }
  .image-details {
    flex-direction: column;
    gap: 0.5rem !important;
    align-items: center;
  }
  .skeleton-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageViewer/style.less"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACI,6DAAA;EACA,iBAAA;AACJ;AAEA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;AAAJ;AAHA;EAMQ,cAAA;EACA,gBAAA;EACA,qBAAA;AAAR;AARA;EAYQ,cAAA;EACA,iBAAA;EACA,qBAAA;AADR;AAbA;EAkBQ,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;AAFR;AAMA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,iBAAA;AAJJ;AAHA;EAUQ,cAAA;EACA,gBAAA;EACA,mBAAA;AAJR;AARA;EAgBQ,cAAA;EACA,qBAAA;AALR;AAOQ;EACI,gBAAA;AALZ;AAUA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;AARJ;AAEA;EASQ,cAAA;EACA,gBAAA;EACA,mBAAA;AARR;AAHA;EAeQ,cAAA;EACA,SAAA;AATR;AACA,iBAAiB;AAajB;EACI,eAAA;AAXJ;AAcA;EACI,aAAA;EACA,4DAAA;EACA,QAAA;EACA,eAAA;AAZJ;AAeA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;AAbJ;AAeI;EACI,sBAAA;AAbR;AAMA;EAWQ,WAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AAdR;AAkBA;EACI;IACI,4DAAA;EAhBN;EAmBE;IACI,aAAA;EAjBN;AACF;AAoBA;EACI;IACI,qCAAA;EAlBN;AACF;AACA,eAAe;AAqBf;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAnBJ;AAqBI;EACI,2BAAA;EACA,0CAAA;AAnBR;AAsBI;EACI,oBAAA;EACA,uBAAA;AApBR;AAuBI;EACI,oBAAA;EACA,uBAAA;AArBR;AAwBI;EACI,oBAAA;EACA,uBAAA;AAtBR;AA0BA;EACI,kBAAA;EACA,WAAA;AAxBJ;AAsBA;;EAKQ,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAvBR;AAeA;EAYQ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;AAxBR;AAMA;EAsBQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAzBR;AAHA;EA+BY,eAAA;EACA,qBAAA;AAzBZ;AA8BA;EACI,kBAAA;AA5BJ;AA2BA;EAIQ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5BR;AAcA;EAiBY,YAAA;EACA,iBAAA;AA5BZ;AAiCA;EACI,aAAA;AA/BJ;AA8BA;EAIQ,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;AA/BR;AAuBA;EAYQ,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,cAAA;AAhCR;AAiBA;;EAkBY,OAAA;AA/BZ;AAaA;EAsBY,iBAAA;AAhCZ;AACA,cAAc;AAqCd;EACI,eAAA;EACA,kBAAA;AAnCJ;AAsCA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AApCJ;AAgCA;EAOQ,cAAA;EACA,SAAA;AApCR;AAwCA;EACI,kBAAA;EACA,eAAA;AAtCJ;AAoCA;EAKQ,cAAA;EACA,SAAA;EACA,kBAAA;AAtCR;AACA,gBAAgB;AA0ChB;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAxCJ;AA2CA;EACI,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAzCJ;AA4CA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,6BAAA;AA1CJ;AAoCA;EASQ,aAAA;EACA,sBAAA;EACA,YAAA;AA1CR;AA+BA;EAcY,YAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AA1CZ;AAyBA;EAqBY,cAAA;EACA,iBAAA;AA3CZ;AAqBA;EA2BQ,aAAA;EACA,WAAA;AA7CR;AAiBA;EA+BY,kBAAA;EACA,yBAAA;AA7CZ;AAkDA;EACI,kBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAhDJ;AA0CA;;EASQ,eAAA;EACA,gBAAA;EACA,mBAAA;AA/CR;AAmDA;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;AAjDJ;AAmDI;EACI,8BAAA;EACA,sCAAA;AAjDR;AAoDI;EACI,UAAA;AAlDR;AAqDI;EACI,WAAA;AAnDR;AAuDA;EACI,oBAAA;EACA,mBAAA;EACA,0BAAA;AArDJ;AAkDA;EAMQ,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AArDR;AA4CA;EAYY,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AArDZ;AAqCA;EAmBgB,cAAA;AArDhB;AACA,qBAAqB;AA2DrB;;EAEI,oBAAA;AAzDJ;AAuDA;;EAKQ,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxDR;AA0DQ;;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAMA,gCAAA;AA5DZ;AAsCA;;EA2BQ,WAAA;EACA,mBAAA;EACA,gBAAA;AA7DR;AAgCA;;EAiCQ,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AA7DR;AA+DQ;;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAMA,gCAAA;AAjEZ;AAWA;;EA2DQ,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAlER;AAoEQ;;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAMA,gCAAA;AAtEZ;AATA;;EAoFQ,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAvER;AAyEQ;;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAMA,gCAAA;AA3EZ;AAgFA;EACI;IACI,WAAA;EA9EN;EAgFE;IACI,UAAA;EA9EN;AACF;AACA,sBAAsB;AAiFtB;EACI;IACI,eAAA;EA/EN;EA8EE;IAIQ,kBAAA;EA/EV;EA2EE;IAQQ,eAAA;EAhFV;EAoFE;IACI,YAAA;EAlFN;EAqFE;IACI,YAAA;EAnFN;EAsFE;IACI,gBAAA;EApFN;EAmFE;IAIQ,sBAAA;IACA,YAAA;EApFV;EA+EE;IAQY,gBAAA;EApFd;EAyFE;IACI,eAAA;IACA,gBAAA;EAvFN;EA0FE;IACI,qBAAA;EAxFN;EAuFE;IAIQ,iBAAA;EAxFV;EAoFE;IAQQ,uBAAA;IACA,iBAAA;EAzFV;EA6FE;IACI,WAAA;IACA,YAAA;IACA,eAAA;EA3FN;EA6FM;IACI,YAAA;EA3FV;EA8FM;IACI,aAAA;EA5FV;EAgGE;IACI,qBAAA;EA9FN;EA6FE;IAIQ,SAAA;IACA,iBAAA;EA9FV;AACF;AACA,mBAAmB;AAkGnB;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,mBAAA;AAhGJ;AAmGA;EACI,WAAA;EACA,aAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;AAjGJ;AAoGA;EACI;IACI,2BAAA;EAlGN;EAoGE;IACI,4BAAA;EAlGN;AACF;AAqGA;EACI,aAAA;EACA,4DAAA;EACA,SAAA;EACA,eAAA;AAnGJ;AACA,8BAA8B;AAsG9B;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AApGJ;AAwFA;EAeQ,YAAA;EACA,iBAAA;AApGR;AAwGA;EACI;IACI,iBAAA;EAtGN;EAyGE;;IACI,YAAA;IACA,oBAAA;EAtGN;EAyGE;IACI,iBAAA;IACA,yBAAA;EAvGN;EA0GE;IACI,sBAAA;IACA,sBAAA;IACA,mBAAA;EAxGN;EA2GE;IACI,qCAAA;EAzGN;AACF","sourcesContent":["/* Image Viewer Page */\n.image-viewer-page {\n    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n    min-height: 100vh;\n}\n\n.viewer-header {\n    text-align: center;\n    padding: 2rem 0;\n    margin-bottom: 2rem;\n    \n    h2 {\n        color: #2c3e50;\n        font-weight: 600;\n        margin-bottom: 0.5rem;\n    }\n    \n    .viewer-subtitle {\n        color: #6c757d;\n        font-size: 1.1rem;\n        margin-bottom: 0.5rem;\n    }\n    \n    .expiry-notice {\n        color: #856404;\n        font-size: 0.9rem;\n        background: #fff3cd;\n        padding: 0.5rem 1rem;\n        border-radius: 20px;\n        display: inline-block;\n        margin: 0;\n    }\n}\n\n.error-card {\n    background: white;\n    border-radius: 20px;\n    padding: 3rem;\n    text-align: center;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n    max-width: 500px;\n    margin: 2rem auto;\n    \n    h3 {\n        color: #dc3545;\n        font-weight: 600;\n        margin-bottom: 1rem;\n    }\n    \n    p {\n        color: #6c757d;\n        margin-bottom: 0.5rem;\n        \n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n}\n\n.no-images {\n    background: white;\n    border-radius: 20px;\n    padding: 3rem;\n    text-align: center;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n    margin: 2rem 0;\n    \n    h4 {\n        color: #2c3e50;\n        font-weight: 600;\n        margin-bottom: 1rem;\n    }\n    \n    p {\n        color: #6c757d;\n        margin: 0;\n    }\n}\n\n/* Masonry Grid */\n.masonry-container {\n    padding: 0 1rem;\n}\n\n.photo-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 8px;\n    padding: 1rem 0;\n}\n\n.photo-item {\n    cursor: pointer;\n    overflow: hidden;\n    border-radius: 8px;\n    transition: transform 0.2s ease;\n    \n    &:hover {\n        transform: scale(1.02);\n    }\n    \n    img {\n        width: 100%;\n        height: 200px;\n        object-fit: cover;\n        display: block;\n    }\n}\n\n@media (max-width: 768px) {\n    .photo-grid {\n        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    }\n    \n    .photo-item img {\n        height: 150px;\n    }\n}\n\n@media (max-width: 576px) {\n    .photo-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n/* Image Card */\n.image-card {\n    background: white;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n    transition: all 0.3s ease;\n    cursor: pointer;\n    break-inside: avoid;\n    \n    &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(0,0,0,0.15);\n    }\n    \n    &.size-small {\n        grid-row-end: span 1;\n        grid-column-end: span 1;\n    }\n    \n    &.size-medium {\n        grid-row-end: span 2;\n        grid-column-end: span 2;\n    }\n    \n    &.size-large {\n        grid-row-end: span 3;\n        grid-column-end: span 3;\n    }\n}\n\n.image-container {\n    position: relative;\n    width: 100%;\n    \n    img, video {\n        width: 100%;\n        height: 100%;\n        display: block;\n        object-fit: contain;\n    }\n    \n    .image-loading {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background: rgba(255,255,255,0.9);\n        padding: 1rem;\n        border-radius: 8px;\n    }\n    \n    .image-error {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        padding: 2rem;\n        color: #6c757d;\n        background: #f8f9fa;\n        \n        i {\n            font-size: 2rem;\n            margin-bottom: 0.5rem;\n        }\n    }\n}\n\n.video-thumbnail {\n    position: relative;\n    \n    .video-overlay {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background: rgba(0,0,0,0.7);\n        border-radius: 50%;\n        width: 60px;\n        height: 60px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        \n        i {\n            color: white;\n            font-size: 1.5rem;\n        }\n    }\n}\n\n.image-info {\n    padding: 1rem;\n    \n    .image-filename {\n        font-weight: 500;\n        color: #2c3e50;\n        margin-bottom: 0.5rem;\n        font-size: 0.9rem;\n        word-break: break-word;\n    }\n    \n    .image-meta {\n        display: flex;\n        justify-content: space-between;\n        font-size: 0.8rem;\n        color: #6c757d;\n        \n        .file-size, .upload-date {\n            flex: 1;\n        }\n        \n        .upload-date {\n            text-align: right;\n        }\n    }\n}\n\n/* Load More */\n.load-more-trigger {\n    padding: 2rem 0;\n    text-align: center;\n}\n\n.loading-more {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n    \n    p {\n        color: #6c757d;\n        margin: 0;\n    }\n}\n\n.end-message {\n    text-align: center;\n    padding: 2rem 0;\n    \n    p {\n        color: #6c757d;\n        margin: 0;\n        font-style: italic;\n    }\n}\n\n/* Image Modal */\n.image-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0,0,0,0.9);\n    z-index: 1050;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1rem;\n}\n\n.image-modal {\n    background: #1a1a1a;\n    border-radius: 12px;\n    max-width: 90vw;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 1.5rem;\n    background: #2c2c2c;\n    border-bottom: 1px solid #444;\n    \n    .modal-title {\n        display: flex;\n        flex-direction: column;\n        gap: 0.25rem;\n        \n        h5 {\n            color: white;\n            margin: 0;\n            font-size: 1rem;\n            font-weight: 500;\n        }\n        \n        .image-counter {\n            color: #adb5bd;\n            font-size: 0.8rem;\n        }\n    }\n    \n    .modal-actions {\n        display: flex;\n        gap: 0.5rem;\n        \n        .btn {\n            border-radius: 6px;\n            padding: 0.375rem 0.75rem;\n        }\n    }\n}\n\n.modal-content {\n    position: relative;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 0;\n    \n    .modal-image, .modal-video {\n        max-width: 100%;\n        max-height: 100%;\n        object-fit: contain;\n    }\n}\n\n.nav-button {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    background: rgba(0,0,0,0.7);\n    border: none;\n    color: white;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.2rem;\n    transition: all 0.3s ease;\n    \n    &:hover {\n        background: rgba(0,0,0,0.9);\n        transform: translateY(-50%) scale(1.1);\n    }\n    \n    &.nav-previous {\n        left: 1rem;\n    }\n    \n    &.nav-next {\n        right: 1rem;\n    }\n}\n\n.modal-footer {\n    padding: 1rem 1.5rem;\n    background: #2c2c2c;\n    border-top: 1px solid #444;\n    \n    .image-details {\n        display: flex;\n        gap: 2rem;\n        justify-content: center;\n        flex-wrap: wrap;\n        \n        .detail-item {\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n            color: #adb5bd;\n            font-size: 0.9rem;\n            \n            i {\n                color: #6c757d;\n            }\n        }\n    }\n}\n\n/* Skeleton Loading */\n.skeleton,\n.image-card:has(.skeleton-container) {\n    pointer-events: none;\n    \n    .skeleton-container {\n        position: relative;\n        overflow: hidden;\n        background: #f0f0f0;\n        \n        &::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: -100%;\n            width: 100%;\n            height: 100%;\n            background: linear-gradient(\n                90deg,\n                transparent,\n                rgba(255, 255, 255, 0.6),\n                transparent\n            );\n            animation: shimmer 1.5s infinite;\n        }\n    }\n    \n    .skeleton-image {\n        width: 100%;\n        background: #e0e0e0;\n        border-radius: 0;\n    }\n    \n    .skeleton-filename {\n        height: 16px;\n        background: #e0e0e0;\n        border-radius: 4px;\n        margin-bottom: 0.5rem;\n        width: 80%;\n        position: relative;\n        overflow: hidden;\n        \n        &::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: -100%;\n            width: 100%;\n            height: 100%;\n            background: linear-gradient(\n                90deg,\n                transparent,\n                rgba(255, 255, 255, 0.6),\n                transparent\n            );\n            animation: shimmer 1.5s infinite;\n        }\n    }\n    \n    .skeleton-filesize {\n        height: 12px;\n        background: #e0e0e0;\n        border-radius: 4px;\n        width: 60px;\n        position: relative;\n        overflow: hidden;\n        \n        &::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: -100%;\n            width: 100%;\n            height: 100%;\n            background: linear-gradient(\n                90deg,\n                transparent,\n                rgba(255, 255, 255, 0.6),\n                transparent\n            );\n            animation: shimmer 1.5s infinite;\n        }\n    }\n    \n    .skeleton-date {\n        height: 12px;\n        background: #e0e0e0;\n        border-radius: 4px;\n        width: 80px;\n        position: relative;\n        overflow: hidden;\n        \n        &::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: -100%;\n            width: 100%;\n            height: 100%;\n            background: linear-gradient(\n                90deg,\n                transparent,\n                rgba(255, 255, 255, 0.6),\n                transparent\n            );\n            animation: shimmer 1.5s infinite;\n        }\n    }\n}\n\n@keyframes shimmer {\n    0% {\n        left: -100%;\n    }\n    100% {\n        left: 100%;\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .viewer-header {\n        padding: 1rem 0;\n        \n        h2 {\n            font-size: 1.75rem;\n        }\n        \n        .viewer-subtitle {\n            font-size: 1rem;\n        }\n    }\n    \n    .masonry-grid {\n        gap: 0.75rem;\n    }\n    \n    .masonry-column {\n        gap: 0.75rem;\n    }\n    \n    .image-info {\n        padding: 0.75rem;\n        \n        .image-meta {\n            flex-direction: column;\n            gap: 0.25rem;\n            \n            .upload-date {\n                text-align: left;\n            }\n        }\n    }\n    \n    .image-modal {\n        max-width: 95vw;\n        max-height: 95vh;\n    }\n    \n    .modal-header {\n        padding: 0.75rem 1rem;\n        \n        .modal-title h5 {\n            font-size: 0.9rem;\n        }\n        \n        .modal-actions .btn {\n            padding: 0.25rem 0.5rem;\n            font-size: 0.8rem;\n        }\n    }\n    \n    .nav-button {\n        width: 40px;\n        height: 40px;\n        font-size: 1rem;\n        \n        &.nav-previous {\n            left: 0.5rem;\n        }\n        \n        &.nav-next {\n            right: 0.5rem;\n        }\n    }\n    \n    .modal-footer {\n        padding: 0.75rem 1rem;\n        \n        .image-details {\n            gap: 1rem;\n            font-size: 0.8rem;\n        }\n    }\n}\n\n/* Image Skeleton */\n.image-skeleton {\n    background: white;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n    margin-bottom: 1rem;\n}\n\n.skeleton-image {\n    width: 100%;\n    height: 200px;\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n    background-size: 200% 100%;\n    animation: skeleton-loading 1.5s infinite;\n}\n\n@keyframes skeleton-loading {\n    0% {\n        background-position: 200% 0;\n    }\n    100% {\n        background-position: -200% 0;\n    }\n}\n\n.skeleton-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 1rem;\n    padding: 1rem 0;\n}\n\n/* Video overlay for gallery */\n.video-overlay-gallery {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: rgba(0,0,0,0.7);\n    border-radius: 50%;\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n    \n    i {\n        color: white;\n        font-size: 1.5rem;\n    }\n}\n\n@media (max-width: 576px) {\n    .masonry-container {\n        padding: 0 0.5rem;\n    }\n    \n    .error-card, .no-images {\n        margin: 1rem;\n        padding: 2rem 1.5rem;\n    }\n    \n    .viewer-header .expiry-notice {\n        font-size: 0.8rem;\n        padding: 0.375rem 0.75rem;\n    }\n    \n    .image-details {\n        flex-direction: column;\n        gap: 0.5rem !important;\n        align-items: center;\n    }\n    \n    .skeleton-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
